import type { PermissionTypes } from '../../@types/Permission';

const Permissions: { [key: string]: PermissionTypes } = {
  BetaFunctionality: 'BetaFunctionality',
  EcomEnabled: 'EcomEnabled',
  AdBoostEnabled: 'AdBoostEnabled',
  AssignmentEnabled: 'AssignmentEnabled',
  WxrBoostEnabled: 'WxrBoostEnabled',
  GenerateVehicleWaykePricePdfEnabled: 'GenerateVehicleWaykePricePdfEnabled',
  GenerateVehicleCustomPricePdfEnabled: 'GenerateVehicleCustomPricePdfEnabled',
  GenerateVehicleVdnPdfEnabled: 'GenerateVehicleVdnPdfEnabled',
  AdDocumentsEnabled: 'AdDocumentsEnabled',
  Ad360ExteriorEnabled: 'Ad360ExteriorEnabled',
  Ad360InteriorEnabled: 'Ad360InteriorEnabled',
  AdEmbeddedVideoEnabled: 'AdEmbeddedVideoEnabled',
  AdContactInformationEnabled: 'AdContactInformationEnabled',
  AdImportMediaEnabled: 'AdImportMediaEnabled',
  LeasingPromosEnabled: 'LeasingPromosEnabled',
  WebhooksEnabled: 'WebhooksEnabled',
  TelephoneNumberGenerationEnabled: 'TelephoneNumberGenerationEnabled',
  OrganizationResellerPackageEnabled: 'OrganizationResellerPackageEnabled',
  WipEnabled: 'WipEnabled',
  WipStockValuationEnabled: 'WipStockValuationEnabled',
  WebsiteEnabled: 'WebsiteEnabled',
  CreditAssessmentEnabled: 'CreditAssessmentEnabled',
  BlocketExportEnabled: 'BlocketExportEnabled',
  ProcessesEnabled: 'ProcessesEnabled',
  OperationsEnabled: 'OperationsEnabled',
  SalesEnabled: 'SalesEnabled',
};

export default Permissions;
